export default __webpack_public_path__ + "static/media/css.1861c541.svg";